<template>
  <div class="app-container">
    <navigation :title="headerTitle"></navigation>
    <div class="list">
      <h1 class="list-title">{{ message.title }}</h1>
      <h1 class="list-subTitle" v-if="message.subTitle">{{ message.subTitle }}</h1>
      <div class="time">时间：{{ message.startTime }}</div>
      <div class="referrer" v-if="message.referrer">来源：{{ message.referrer }}</div>
      <div class="main" v-html="message.contentHtml"></div>
      <div class="collect-share">
        <div class="collect">
          <collect v-if="message" :resource="resource"></collect>
        </div>
<!--        <div class="share"  @click="share">-->
<!--          分享至：<svg-icon iconClass='share' className='share-icon'></svg-icon>-->
<!--        </div>-->
      </div>
      <page-share :show="showShare" @show='getShow' :title="resource.module"></page-share>
    </div>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, List, Icon, Checkbox } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'
import pageShare from '../../components/pageShare'
import collect from '../../components/collect'
import {parseTime} from '../../untils/formatTime'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox)
export default {
  name: 'newsDetail',
  components: {navigation, version, pageShare, collect},
  data () {
    return {
      message: '',
      headerTitle: '',
      showShare: false,
      resource:{
        title: '',
        module: '',
        resourceId:this.$route.query.id
      }
    }
  },
  created () {
    // 新闻详情
    this.getDetail()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    getDetail () {
      let information = {
        informationId: this.$route.query.id
      }
      console.log('this.informationId', this.$route)
      request('post', '/nlc-web/api/information/info', information).then(res => {
        console.log('详情', res)
        res.data.startTime = parseTime(res.data.startTime,'{y}-{m}-{d}')
        this.message = res.data
        if(res.data.informationType === "INFORMATION_NOTICE"){
          this.resource.module = '最新公告'
        } else if (res.data.informationType === "INFORMATION_NEWS") {
          this.resource.module = '国图新闻'
        } else if (res.data.informationType === "INFORMATION_SOLICITATION") {
          this.resource.module = '征集启事'
        }
        this.resource.title = res.data.title
        // 设置标题
        this.headerTitle = this.resource.module
      })
    },
    share () {
      this.showShare = true
    },
    getShow (msg) {
      this.showShare = msg
    }
  }
}
</script>

<style scoped>
.app-container{
  overflow-y:scroll;
  overflow-X:hidden;
  background:#ecf5fd;
  min-height: calc(100% - .92rem);
  position: absolute;
  top: 0px;
  bottom: 0px;
}
.list{
  width:6.1rem;
  margin:1.18rem .28rem .34rem .28rem;
  padding:.44rem .42rem;
  background:#fff;
  border-radius:8px;
  font-family: SourceHanSerifCN-SemiBold;
}
.list-title{
  font-size:.36rem;
}
.list-subTitle{
  font-size:.28rem;
  font-weight: normal;
  text-align:right;
}
h1{
  color:#444649;
  width:100%;
  text-align: center;
  word-wrap:break-word;
}
.time{
  font-size:.24rem;
  color:#999;
  width:100%;
  text-align:center;
  margin:.26rem 0 0 0;
}
.referrer{
  font-size:.24rem;
  color:#999;
  width:100%;
  text-align:center;
  margin:0 0 .39rem 0;
}
.main{
  color:#333;
  font-size:.32rem;
  line-height:.52rem;
  word-break: break-all;
}
.main >>>p span{
  font-family: SourceHanSerifCN-Regular !important;
  word-wrap:break-word;
}
>>>.image{
  width:100%;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  text-indent: 0;
}
>>>img{
  width:100%;
  margin:0;
  padding:0;
}
.collect-share{
  display:flex;
}
.share{
  color:#444649;
  font-size:.24rem;
  margin-left:.22rem;
  line-height: .57rem;
}
>>>.collect-main{
  margin-left:0 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/newsDetail/index.vue